export default __webpack_public_path__ + "static/media/appfull.b824790d.webp";